export const ANY = 'ANY';
export const PENDING = 'PENDING';
export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
export const BUDGET = 'Budget';
export const REVENUE = 'Revenue';
export const ELLIGO = 'Elligo';
export const CLIENT = 'Client';
